import { legoInit, legoPerf } from '@zz-common/lego'
import Vue from 'vue'
import { SentryVueInit } from '@zz-common/sentry'
import { Button, Toast, ClickEffect, ImagePreview } from '@zz-common/zz-ui'
import '@zz/sasscore/flexible.js'
import ErrorBoundary from './lib/ErrorBoundary'
import pageIdConfig from '@/lib/pageIdConfig'
import router from '@router'
import App from './App'
// 全局初始化乐高埋点的值，默认合入backup
legoInit(Object.assign({ stayUserTime: true }, pageIdConfig))

try {
  legoPerf()
  SentryVueInit()
} catch (err) {
  console.warn(err)
}
Vue.use(Button, { v9: true })
Vue.use(Toast)
Vue.use(ClickEffect);
Vue.use(ImagePreview);
Vue.use(ErrorBoundary)

// 业务代码
window.vm = new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})
